export default "__VITE_ASSET__8tHPpLAE__"